<div class="shadow-sm p-1.5 -mt-5 lg:-mt-5 xl:-mt-3 bg-[#F5F5F7] -mx-5">
  <div class="relative">
    <div class="pl-3">
      <div class="flex gap-7 items-center flex-wrap">
        <!-- Audit Type -->
        @if (auditType != null) {
          <div class="flex gap-2">
            <label [ngClass]="labelClass"> Audit Type : </label>
            <p [ngClass]="valueClass">{{ auditType || "-" }}</p>
          </div>
        }

        <!-- Region -->
        @if (showRegion) {
          <div
            class="flex gap-2 relative before:content-[''] before:absolute before:left-[-14px] before:top-1/2 before:-translate-y-1/2 before:h-5 before:w-[1px] before:bg-gray-300"
          >
            <label [ngClass]="labelClass"> Region : </label>
            <p [ngClass]="valueClass">{{ region || "-" }}</p>
          </div>
        }

        <!-- Branch -->
        @if (showBranch) {
          <div
            class="flex gap-2 relative before:content-[''] before:absolute before:left-[-14px] before:top-1/2 before:-translate-y-1/2 before:h-5 before:w-[1px] before:bg-gray-300"
          >
            <label [ngClass]="labelClass"> Branch : </label>
            <p [ngClass]="valueClass">{{ branch || "-" }}</p>
          </div>
        }

        <!-- From Date / To Date (when both provided) -->
        @if (fromDate != null && toDate != null) {
          <div
            class="flex gap-2 relative before:content-[''] before:absolute before:left-[-14px] before:top-1/2 before:-translate-y-1/2 before:h-5 before:w-[1px] before:bg-gray-300"
          >
            <label [ngClass]="labelClass"> From Date : </label>
            <p [ngClass]="valueClass">{{ fromDate || "-" }}</p>
          </div>
          <div
            class="flex gap-2 relative before:content-[''] before:absolute before:left-[-14px] before:top-1/2 before:-translate-y-1/2 before:h-5 before:w-[1px] before:bg-gray-300"
          >
            <label [ngClass]="labelClass"> To Date : </label>
            <p [ngClass]="valueClass">{{ toDate || "-" }}</p>
          </div>
        } @else if (showDateTime) {
          <!-- Date (when fromDate/toDate not used) -->
          <div
            class="flex gap-2 relative before:content-[''] before:absolute before:left-[-14px] before:top-1/2 before:-translate-y-1/2 before:h-5 before:w-[1px] before:bg-gray-300"
          >
            <label [ngClass]="labelClass"> Date : </label>
            <p [ngClass]="valueClass">{{ date || "-" }}</p>
          </div>
          <!-- Time -->
          <div
            class="flex gap-2 relative before:content-[''] before:absolute before:left-[-14px] before:top-1/2 before:-translate-y-1/2 before:h-5 before:w-[1px] before:bg-gray-300"
          >
            <label [ngClass]="labelClass"> Time : </label>
            <p [ngClass]="valueClass">{{ time || "-" }}</p>
          </div>
        }
      </div>
    </div>
  </div>
</div>
